import React, { useState, useEffect } from 'react';
import Carousel from "./Carousel";
import jwtCookieManager from "./jwtCookieManager";
import './login.css';

export default function LoginPage() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [authCode, setAuthCode] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [showAuth, setShowAuth] = useState(false);

    // Hide carousel on mobile (width < 768px)
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        // First step: show auth code field
        if (!showAuth) {
            setShowAuth(true);
            return;
        }

        setLoading(true);
        try {
            const res = await fetch(process.env.REACT_APP_AUTH_API_URL, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ username:email, password, verificationCode:authCode }),
            });
            const data = await res.json();
            console.log('Response:', data);
            if (!res.ok) throw new Error(data.error || 'Login failed');

            jwtCookieManager.setToken(data.token);
            window.location.href = process.env.REACT_APP_ADMIN_URL;
        } catch (err) {
            setError('Login failed');
            // Return to the email/password step while preserving entered data
            setShowAuth(false);
            setAuthCode('');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="demo-container">
            {/* Left side: Login Form */}
            <div className="left-side">
                <div style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    textAlign: 'center'
                }}>
                    <h2>Login to Your Account</h2>
                    {error && <p className="error">{error}</p>}
                    <form onSubmit={handleSubmit}>
                        <input
                            className="input-field"
                            type="email"
                            placeholder="Email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                        <input
                            className="input-field"
                            type="password"
                            placeholder="Password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                        {showAuth && (
                            <input
                                className="input-field"
                                type="text"
                                placeholder="Auth Code"
                                value={authCode}
                                onChange={(e) => setAuthCode(e.target.value)}
                                required
                            />
                        )}
                        <button type="submit" disabled={loading}>
                            {loading
                                ? 'Submitting...'
                                : showAuth ? 'Submit' : 'Next'}
                        </button>
                    </form>
                    <div className="login-links">
                        <a href="/forgot-password">Forgot Password?</a>
                        <span> | </span>
                        <a href="/signup">Sign Up</a>
                    </div>
                </div>
                <div className="footer-demo">
                    <div style={{ paddingTop: 10 }}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="120.125" height="30.965" viewBox="0 0 208.125 56.965">
                            <defs>
                                <clipPath id="clip-path">
                                    <rect width="208.125" height="56.965" fill="none" stroke="#ff9200" strokeWidth="1"/>
                                </clipPath>
                                <clipPath id="clip-path-2">
                                    <rect width="208.125" height="56.965" fill="none"/>
                                </clipPath>
                            </defs>
                            <g transform="translate(-365.811 -22)">
                                <g transform="translate(365.811 22)">
                                    <g clipPath="url(#clip-path)">
                                        <text transform="translate(0 31.465)" fill="#f7981d" stroke="#ff9200" strokeWidth="1" fontSize="36" fontFamily="Helvetica-Bold, Helvetica" fontWeight="700">V</text>
                                        <text transform="translate(22.047 31.465)" fill="#f7981d" stroke="#ff9200" strokeWidth="1" fontSize="37" fontFamily="Helvetica-Bold, Helvetica" fontWeight="700">oice</text>
                                        <text transform="translate(96.443 31.465)" fill="#b2b2b2" fontSize="37" fontFamily="Helvetica-BoldOblique, Helvetica" fontWeight="700" fontStyle="oblique">PRO</text>
                                        <text transform="translate(181.715 8.75)" fill="#989897" fontSize="7" fontFamily="Helvetica">T</text>
                                        <text transform="translate(187.015 9.75)" fill="#989897" fontSize="8" fontFamily="Helvetica">M</text>
                                        <path d="M24.251,34.473a3.718,3.718,0,1,1-3.718-3.718,3.718,3.718,0,0,1,3.718,3.718" transform="translate(4.024 7.36)" fill="#e6e6e6"/>
                                        <circle cx="3.718" cy="3.718" r="3.718" transform="translate(20.838 38.115)" fill="none" stroke="#ccc" strokeMiterlimit="10" strokeWidth="1"/>
                                        <path d="M15.25,34.473a3.718,3.718,0,1,1-3.718-3.718,3.718,3.718,0,0,1,3.718,3.718" transform="translate(1.87 7.36)" fill="#e6e6e6"/>
                                        <circle cx="3.718" cy="3.718" r="3.718" transform="translate(9.685 38.115)" fill="none" stroke="#ccc" strokeMiterlimit="10" strokeWidth="1"/>
                                    </g>
                                </g>
                                <text transform="translate(411.026 67.416)" fill="#e0e0e0" fontSize="13" fontFamily="Helvetica" letterSpacing="0.229em">communications</text>
                                <g transform="translate(365.811 22)">
                                    <g clipPath="url(#clip-path-2)">
                                        <path d="M33.251,34.473a3.718,3.718,0,1,1-3.718-3.718,3.718,3.718,0,0,1,3.718,3.718" transform="translate(6.178 7.36)" fill="#e6e6e6"/>
                                        <circle cx="3.718" cy="3.718" r="3.718" transform="translate(31.992 38.115)" fill="none" stroke="#ccc" strokeMiterlimit="10" strokeWidth="1"/>
                                    </g>
                                </g>
                            </g>
                        </svg>
                    </div>
                    <div>VoicePro Communications, Inc. @ 2025</div>
                    <div>
                        <a href="/terms">Terms of Use</a> | <a href="/privacy">Privacy</a>
                    </div>
                </div>
            </div>
            {/* Right side: Carousel (hidden on mobile) */}
            {!isMobile && (
                <div className="carousel-container">
                    <Carousel />
                </div>
            )}
        </div>
    );
}
